export default __webpack_public_path__ + "assets/icon-service-component.50f47d80.svg";